module.exports = __webpack_public_path__ + "static/img/3.5dc3b34.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/eng/3.png
// module id = Teqo
// module chunks = 0